<template>
    <overview
        v-if="!globalLoading"
        :name="name"
        :dataoverview="dataoverview"
        :mappingName="mappingName"
        :overviewClass="overviewClass"
        :nav="navMap"
        :moreNav="moreNav"
        :contextId="contextId"
    >
        <template #header>
            <overview-header-opportunity :overviewhash="overviewhash" :actions="headerActions" />
        </template>
    </overview>
</template>

<script>
import Overview from 'vcomponents/overview/Overview.vue';
import OverviewHeaderOpportunity from '../overview/OverviewHeaderOpportunity.vue';
import OverviewOpportunityModule from '../../store/overview/overviewOpportunity';
import OverviewMixin from '../overview/OverviewMixin';

import { createNamespacedHelpers } from 'vuex';
const { mapState, mapActions } = createNamespacedHelpers('system');

export default {
    mixins: [OverviewMixin],

    data() {
        return {
            overviewhash: '',
            headerActions: [],
            module: OverviewOpportunityModule,
        };
    },

    created() {
        const {
            headerActions,
        } = require(`../overview/tabs/mapping/${this.overviewClass.mappingName}Mapping`);
        this.headerActions = headerActions;

        this.init(this.$route.params.id);
    },
    computed: {
        ...mapState({
            globalLoading: 'globalLoading',
        }),
    },
    methods: {
        ...mapActions(['toggleLoading']),
        init(id) {
            this.moreNav = [];
            this.navMap = [];

            this.toggleLoading();
            this.overviewClass
                .fetch(id)
                .then((response) => {
                    this.initStore(response).then(() => {
                        this.moreNav = this.overviewClass.getMoreNav();
                        this.navMap = this.buildNav(this.overviewClass.getNav());
                        this.setDataoverview();
                        this.dispatchData();
                        this.toggleLoading();
                    });
                })
                .catch((error) => {
                    Push.error(this.$l10n.__("Vous n'avez pas les droits nécessaires"));
                    this.toggleLoading();
                    this.$router.push({ name: 'opportunities' });
                });
        },
    },
    beforeUnmount() {
        this.$store.unregisterModule('opportunity');
    },
    components: {
        Overview,
        OverviewHeaderOpportunity,
    },
};
</script>
